/* Fraclit Discovery 2 — native Shopify commerce and accessible story controls. */
(() => {
  'use strict';
  const toast = (message) => {
    const node = document.getElementById('FraclitStatus');
    if (!node) return;
    node.textContent = message;
    node.classList.add('is-visible');
    clearTimeout(node._timer);
    node._timer = setTimeout(() => node.classList.remove('is-visible'), 6500);
  };

  const validateCartQuantity = input => {
    const value = Number(input.value), min = Number(input.dataset.lineMin) || 1, step = Number(input.dataset.lineStep) || 1;
    const valid = input.value !== '' && Number.isInteger(value) && value >= 0 && (value === 0 || (value >= min && (value - min) % step === 0));
    input.setCustomValidity(valid ? '' : `Choose 0 to remove this item, or at least ${min} in steps of ${step}.`);
    return valid;
  };
  document.addEventListener('input', event => { if (event.target.matches('input[data-line-min]')) validateCartQuantity(event.target); });
  // Use Shopify's cart API. Only navigate after a confirmed successful add.
  document.addEventListener('submit', async (event) => {
    const cart = event.target.closest('form.cart-form');
    if (cart) { cart.querySelectorAll('input[data-line-min]').forEach(validateCartQuantity); if (!cart.reportValidity()) event.preventDefault(); return; }
    const form = event.target.closest('form[data-add-to-cart]');
    if (!form || !window.fetch || !window.Fraclit) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    if (button?.disabled) return;
    const variantSelect = form.querySelector('[data-variant-select]');
    const variant = new FormData(form).get('id');
    if (!variant) { toast(window.Fraclit.strings.error); return; }
    const original = button?.innerHTML;
    const wasSelectDisabled = variantSelect?.disabled;
    const error = form.querySelector('.form-error');
    if (error) error.hidden = true;
    form.dataset.busy = 'true';
    if (button) { button.disabled = true; button.textContent = window.Fraclit.strings.adding; }
    try {
      const body = new FormData(form);
      body.delete('return_to');
      if (variantSelect) variantSelect.disabled = true;
      const response = await fetch(window.Fraclit.add, { method: 'POST', body, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      const payload = await response.json().catch(() => null);
      if (!response.ok || !payload || payload.status >= 400 || (!payload.id && !payload.items?.length)) throw new Error(typeof payload?.description === 'string' ? payload.description : window.Fraclit.strings.error);
      window.location.assign(window.Fraclit.cart);
    } catch (exception) {
      const message = exception.message || window.Fraclit.strings.error;
      if (error) { error.textContent = message; error.hidden = false; } else toast(message);
      if (button) { button.disabled = variantSelect?.selectedOptions[0]?.dataset.available === 'false'; button.innerHTML = button.disabled ? window.Fraclit.strings.soldOut : original; }
      if (variantSelect) variantSelect.disabled = wasSelectDisabled;
      delete form.dataset.busy;
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-change]');
    if (button) {
      const input = button.closest('[data-quantity]')?.querySelector('input');
      if (!input) return;
      const step = Number(input.dataset.lineStep || input.step) || 1;
      const min = Number(input.min) || 0;
      const max = input.max ? Number(input.max) : Infinity;
      let value = Math.min(max, Math.max(min, (Number(input.value) || min) + step * Number(button.dataset.quantityChange)));
      const lineMin = Number(input.dataset.lineMin) || min;
      if (value > 0 && value < lineMin) value = Number(button.dataset.quantityChange) < 0 ? 0 : lineMin;
      input.value = String(value);
      if (input.hasAttribute('data-line-min')) validateCartQuantity(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (!event.target.closest('.mobile-menu') || event.target.closest('.mobile-menu nav a')) document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open')); });
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const scope = select.closest('.product-information');
    if (!option || !scope) return;
    const button = scope.querySelector('[data-product-add]');
    const price = scope.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price || '';
    if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? window.Fraclit.strings.soldOut : button.dataset.label; }
    const input = scope.querySelector('input[name="quantity"]');
    if (input) {
    input.min = option.dataset.min || '1'; input.step = option.dataset.step || '1';
    if (option.dataset.max) input.max = option.dataset.max; else input.removeAttribute('max');
    input.value = input.min;
    }
    const url = new URL(window.location.href); url.searchParams.set('variant', select.value); window.history.replaceState({}, '', url);
  });

  // Product images use real links as a no-JavaScript fallback.
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-gallery-image]');
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const gallery = link.closest('[data-book-gallery]');
      const picture = gallery?.querySelector('.book-main-image');
      if (!picture) return;
      event.preventDefault();
      picture.removeAttribute('srcset'); picture.removeAttribute('sizes');
      picture.src = link.dataset.imageSrc; picture.alt = link.dataset.imageAlt || '';
      const frame = gallery.querySelector('.spotlight-gallery__main');
      if (frame && link.dataset.referenceCrop) frame.dataset.referenceCrop = link.dataset.referenceCrop;
      gallery.querySelectorAll('[data-gallery-image]').forEach(item => item.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'true');
    }
    const choice = event.target.closest('[data-fraction]');
    if (!choice) return;
    const lab = choice.closest('.fraction-lab');
    const display = lab?.querySelector('[data-fraction-display]');
    const values = {half:['½','0.50','50%','180deg','#f89940'],quarter:['¼','0.25','25%','90deg','#b8d776'],fifth:['⅕','0.20','20%','72deg','#6ec6ae']}[choice.dataset.fraction];
    if (!display || !values) return;
    lab.querySelectorAll('[data-fraction]').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
    display.style.setProperty('--slice', values[3]); display.style.setProperty('--slice-colour', values[4]);
    display.querySelector('.fraction-disc span').textContent = values[0];
    ['fraction','decimal','percent'].forEach((name,i) => display.querySelector(`[data-value-${name}]`).textContent = values[i]);
  });

  class FraclitJourney extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.controller = new AbortController();
      this.panels = [...this.querySelectorAll('[data-story-panel]')];
      this.dots = [...this.querySelectorAll('[data-scene-dot]')];
      this.host = this.querySelector('[data-scene]');
      this.sticky = this.querySelector('.journey__sticky');
      this.index = -1;
      this.progress = 0;
      this.visible = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.panels.length || !this.host) return;
      this.host.tabIndex = 0;
      const on = (target, type, fn, options = {}) => target?.addEventListener(type, fn, { ...options, signal: this.controller.signal });
      const update = () => { if (!this._scrollFrame) this._scrollFrame = requestAnimationFrame(() => { this._scrollFrame = 0; this.syncScroll(); }); };
      on(window, 'scroll', update, { passive: true });
      const resize = () => { this.checkLayout(); update(); };
      on(window, 'resize', resize, { passive: true });
      // Mobile browser chrome changes height during a swipe. Only the viewport
      // listener may change the pinned layout; observing our own sticky box loops.
      this.dots.forEach(dot => on(dot, 'click', () => this.goTo(Number(dot.dataset.sceneDot))));
      on(this.querySelector('[data-scene-prev]'), 'click', () => this.goTo(this.index - 1));
      on(this.querySelector('[data-scene-next]'), 'click', () => this.goTo(this.index + 1));
      on(this.querySelector('[data-reset-orbit]'), 'click', () => this.scene?.resetOrbit());
      on(this.host, 'keydown', (event) => {
        if (event.target !== this.host) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.scene?.orbitBy(event.key === 'ArrowLeft' ? -.25 : .25); }
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') { event.preventDefault(); this.goTo(this.index + (event.key === 'ArrowDown' ? 1 : -1)); }
        if (event.key === 'Home') { event.preventDefault(); this.goTo(0); this.scene?.resetOrbit(); }
      });
      on(document, 'shopify:block:select', (event) => { const panel = event.target.closest('[data-story-panel]'); if (panel && this.contains(panel)) this.goTo(Number(panel.dataset.index), true); });
      on(document, 'visibilitychange', () => this.scene?.setVisible(this.visible && !document.hidden));
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.scene?.setVisible(this.visible && !document.hidden);
        if (this.visible && !this._loading) this.loadScene();
      }, { rootMargin: '120px' });
      this.observer.observe(this.host);
      document.fonts?.ready.then(() => { if (this.isConnected) resize(); });
      this.checkLayout();
      this.syncScroll();
    }
    async loadScene() {
      this._loading = true;
      if (this.dataset.enable3d !== 'true') { this.classList.add('is-fallback'); return; }
      try {
        const module = await import(this.dataset.sceneModule);
        if (!this.isConnected) return;
        this.scene = module.createScene(this.host, { bookTextureUrl: this.dataset.bookTexture, motion: this.dataset.gentleMotion !== 'false' && !this.reduced, reduced: this.reduced, quality: Number(this.dataset.quality) || 2, onReady: () => { if (this.isConnected) { this.classList.add('is-ready'); this.classList.remove('is-fallback'); } }, onError: () => { this.classList.remove('is-ready'); this.classList.add('is-fallback'); } });
        this.scene.setProgress(this.progress / Math.max(1, this.panels.length - 1));
        this.scene.setVisible(this.visible && !document.hidden);
      } catch (error) { this.classList.remove('is-ready'); this.classList.add('is-fallback'); }
    }
    checkLayout() {
      const width = window.innerWidth || document.documentElement.clientWidth;
      const height = window.innerHeight || document.documentElement.clientHeight;
      const portrait = width < 750 && height > width;
      // Latch mobile height until the width/orientation changes. Address-bar
      // animation must never move the scene boundaries under the visitor.
      if (this._layoutWidth === width && (portrait || this._layoutHeight === height)) return;
      this._layoutWidth = width;
      this._layoutHeight = height;
      this.style.setProperty('--journey-height', `${height}px`);
      const heading = this.panels[0]?.querySelector('h1,h2');
      const enlarged = heading && parseFloat(getComputedStyle(heading).fontSize) > (portrait ? 62 : 126);
      this.classList.toggle('journey--flow', !!enlarged || height < 390 || (portrait && height < 590));
    }
    syncScroll() {
      if (!this.isConnected) return;
      const sticky = this.querySelector('.journey__sticky');
      const header = parseFloat(getComputedStyle(sticky).top) || 0;
      const distance = Math.max(1, this.offsetHeight - sticky.offsetHeight);
      const relative = header - this.getBoundingClientRect().top;
      let unit = Math.max(0, Math.min(1, relative / distance));
      const flow = this.classList.contains('journey--flow');
      if (flow) { let current = 0; this.panels.forEach((panel, i) => { if (panel.getBoundingClientRect().top <= window.innerHeight * .55) current = i; }); unit = current / Math.max(1, this.panels.length - 1); }
      this.progress = unit * Math.max(1, this.panels.length - 1);
      let index = Math.min(this.panels.length - 1, Math.round(this.progress));
      // A small dead band prevents bounce/subpixel jitter replaying a scene.
      if (!flow && this.index >= 0 && Math.abs(this.progress - this.index) < .58) index = this.index;
      if (index !== this.index || this._flow !== flow) {
        this.index = index;
        this._flow = flow; this.dataset.sceneIndex = String(index);
        const posterIndex = Math.round(index / Math.max(1, this.panels.length - 1) * 3);
        this.querySelectorAll('[data-poster-index]').forEach((poster) => poster.classList.toggle('is-current', Number(poster.dataset.posterIndex) === posterIndex));
        this.panels.forEach((panel, i) => { const active = i === index; panel.classList.toggle('is-active', active); panel.inert = !active && !flow; panel.setAttribute('aria-hidden', String(!active && !flow)); });
        this.dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); if (i === index) dot.setAttribute('aria-current', 'step'); else dot.removeAttribute('aria-current'); });
        this.querySelector('[data-scene-prev]').disabled = index === 0;
        const next = this.querySelector('[data-scene-next]');
        next.disabled = false;
        next.setAttribute('aria-label', index === this.panels.length - 1 ? 'Continue to book details' : 'Next scene');
        next.textContent = index === this.panels.length - 1 ? '↓' : '→';
        this.querySelector('[data-scene-number]').textContent = `${String(index + 1).padStart(2, '0')} / ${String(this.panels.length).padStart(2, '0')}`;
      }
      this.scene?.setProgress(this.reduced ? index / Math.max(1, this.panels.length - 1) : unit);
      this.style.setProperty('--journey-progress', String(unit));
    }
    goTo(index, instant = false) {
      if (index >= this.panels.length) {
        const top = window.scrollY + this.getBoundingClientRect().bottom - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72);
        window.scrollTo({top, behavior: instant || this.reduced ? 'instant' : 'smooth'});
        return;
      }
      const target = Math.max(0, Math.min(this.panels.length - 1, index));
      if (this.classList.contains('journey--flow')) { this.panels[target].scrollIntoView({ behavior: instant || this.reduced ? 'instant' : 'smooth', block: 'start' }); return; }
      const sticky = this.querySelector('.journey__sticky');
      const header = parseFloat(getComputedStyle(sticky).top) || 0;
      const start = window.scrollY + this.getBoundingClientRect().top - header;
      const distance = Math.max(1, this.offsetHeight - sticky.offsetHeight);
      window.scrollTo({ top: start + distance * target / Math.max(1, this.panels.length - 1), behavior: instant || this.reduced ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect(); this.resizeObserver?.disconnect();
      cancelAnimationFrame(this._scrollFrame); this.scene?.dispose(); this.scene = null; this._connected = false; this._loading = false;
    }
  }
  if (!customElements.get('fraclit-journey')) customElements.define('fraclit-journey', FraclitJourney);
})();
